import * as userActions from '../../reducers/user';

const updateTeamValue = (key, value) => (dispatch) => {
  dispatch(userActions.updateTeamValue({ key, value }));
};

export default updateTeamValue;
